import { useMutation } from '@connectrpc/connect-query'
import { exportCisContracts } from '@ebalance/proto/bffuser/v1/cis_contract_service-CisContractService_connectquery'

import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 供給地点マスタ (CIS契約マスタ) CSV エクスポート用の全件取得フック
 * (uploads/common.md §6 AC-DUC-028/029)。
 *
 * `useMutation` を使う (= ダウンロード
 * モーダルを開いた時の 1 回限りの命令的取得であり、 cache には載せない)。
 */
export function useExportCisContracts(): InvalidatingMutationResultFor<
  typeof exportCisContracts
> {
  return useMutation(exportCisContracts)
}
